import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';

// Kurulum tamamlanmadıysa uygulama ekranları yerine kilit ekranı gösterilir; Platform Sahibi sayfası açık kalır
export const SetupGate = ({ children }) => {
  const { pathname } = useLocation();
  const [locked, setLocked] = useState(false);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/setup-status`).then((r) => setLocked(!!r.data.locked)).catch(() => {});
  }, []);
  if (!locked || pathname.startsWith('/platform-owner')) return children;
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6" data-testid="setup-locked-screen">
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-orange-50 text-orange-500"><Lock className="h-6 w-6" /></span>
        <h1 className="mt-4 text-xl font-semibold text-slate-900">Kurulum tamamlanmadı</h1>
        <p className="mt-2 text-sm text-slate-500">Sistem, Platform Sahibi ilk kurulumu tamamlayana kadar kullanıma kapalıdır.</p>
        <a href="/platform-owner" className="mt-5 inline-block text-sm font-medium text-orange-600 hover:underline" data-testid="setup-locked-owner-link">Platform Sahibi girişi</a>
      </div>
    </div>
  );
};
